import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Link from "@material-ui/core/Link";
import AppBar from "@material-ui/core/AppBar";
import Container from "@mui/material/Container";
import logo from "../assets/header/logo.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import PlainHeader from "../components/PlainHeader";

import { GoogleLogin } from "react-google-login";
import { Post } from "react-axios";
import { capitalize, clientID, getURLBase } from "../utils/helperFns";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import GoogleIcon from "@mui/icons-material/Google";
import { Button } from "@mui/material";

import LoginBottom from "../assets/login/login_bg_bottom.png";
import LoginTop from "../assets/login/login_bg_top.png";
import LoginTopBottom from "../assets/login/group_login_bg.png";
import GoogleLogo from "../assets/login/google_logo.png";
import Google from "../assets/login/google.svg";
import { Icon } from "@material-ui/core";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/loginid";
    this.state = {
      loggedIn: false,
    };
  }

  onLoginSuccess = (res) => {
    this.setState({
      loggedIn: true,
      gid: res.getAuthResponse().id_token,
    });
  };

  showLogin = () => {
    const cid = clientID();
    return (
      <GoogleLogin
        clientId={cid}
        render={(renderProps) => (
          <button
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 40,
              paddingRight: 40,
              borderRadius: 55,
              backgroundColor: "#FFF",
              borderWidth: 0,
              boxShadow: "1px 1px 1px 1px #9E9E9E",
            }}
          >
            <Icon>
              <img src={GoogleLogo} style={{ width: "18px", height: "18px" }} />
            </Icon>
            <Typography
              display="inline"
              style={{ fontSize: 16, marginLeft: 5 }}
            >
              Login with Google
            </Typography>
          </button>

          // <Button
          //   onClick={renderProps.onClick}
          //   disabled={renderProps.disabled}
          //   variant="outlined"
          //   sx={{ borderRadius: 10 }}
          //   // startIcon={<Google />}
          // >
          //   <>
          //     <img src={require(GoogleLogo)} />
          //     <Typography display="inline" style={{ fontSize: 16 }}>
          //       Login with Google
          //     </Typography>
          //   </>
          // </Button>
        )}
        buttonText="Login"
        onSuccess={this.onLoginSuccess}
        // onFailure={responseGoogle}
        cookiePolicy={"single_host_origin"}
      />

      // <GoogleLogin
      //   clientId={cid}
      //   onSuccess={this.onLoginSuccess}
      //   cookiePolicy={"single_host_origin"}
      //   style={{
      //     border: 1,
      //     borderRadius: "15px",
      //     marginTop: 40,
      //     borderCollapse: "collapsed",
      //     overflow: "hidden",
      //   }}
      //   render={(renderProps) => {
      //     <Button
      //       variant="outlined"
      //       sx={{ borderRadius: 10 }}
      //       startIcon={<GoogleIcon />}
      //     >
      //       <Typography variant="h5" display="inline">
      //         Login with Google
      //       </Typography>
      //     </Button>;
      //   }}
      // />
    );
  };

  showLoggingIn = () => {
    return (
      <Post url={this.url} data={{ gid: this.state.gid }}>
        {(error, response, isLoading) => {
          if (error) {
            return <div>Could not login: {error.message}</div>;
          } else if (isLoading) {
            window.history.replaceState(null, "Wyzr", "/home");

            return <div>Loading...</div>;
          } else if (response !== null) {
            console.log("Login response: ", response);
            if (response.data?.body?.responseStatus === 200) {
              this.props.loginSuccess(
                response.data.body.sessionId,
                capitalize(response.data.body.firstName),
                response.data.body.hasActiveAccounts
              );
              return <div>Redirecting...</div>;
            } else {
              return (
                <div>
                  Failed to authenticate with the backend. Please contact
                  info@wyzr.co.uk
                </div>
              );
            }
          } else {
            return <div>Error:: Reload App</div>;
          }
        }}
      </Post>
    );
  };

  showLoginBar = () => {
    if (this.state.loggedIn) {
      return this.showLoggingIn();
    } else {
      return this.showLogin();
    }
  };

  render() {
    return (
      <>
        <AppBar
          title="Wyzr"
          sx={{
            minHeight: `60px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            zIndex: 1000,
          }}
        >
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logo}
              alt="wyzr logo"
              style={{ width: 40, height: 40, margin: "0 8px" }}
            />

            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, fontSize: "14px", fontWeight: "bold" }}
            >
              Wyzr
            </Typography>
          </Container>

          <Container
            component={Link}
            to="/profile"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 0.4,
              color: "white",
              textDecoration: "none",
            }}
          >
            <Button
              // onClick={renderProps.onClick}
              // disabled={renderProps.disabled}
              variant="outlined"
              sx={{
                width: 200,
                borderRadius: 6,
                borderColor: "#FFF",
                height: "20px",
                padding: 2,
              }}
            >
              <Typography fontSize={14} display="inline" color="#FFF">
                Beta Version 0.6.3
              </Typography>
            </Button>
          </Container>
        </AppBar>

        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{
            paddingTop: 70,
            backgroundColor: "#FFF",
            backgroundImage: `url(${LoginTop})`,
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* <Grid item>
            <img
              src={logo}
              alt="wyzr logo"
              style={{ width: 80, height: 80, margin: "0 8px" }}
            />
          </Grid> */}
          <Grid item>
            <Typography
              display="inline"
              style={{ fontSize: 36, fontWeight: "bold" }}
            >
              Welcome to
            </Typography>
            &nbsp;
            <Typography
              color="#008036"
              style={{ fontSize: 36, fontWeight: "bold" }}
              display="inline"
            >
              Wyzr
            </Typography>
            {/* <Typography
              color="#008036"
              style={{ fontSize: 14, fontWeight: "bold" }}
              display="inline"
            >
              0.5.10
            </Typography> */}
          </Grid>
          <Grid item>
            <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
              Start your Financial Wellbeing journey here
            </Typography>
          </Grid>
          <Grid style={{ marginTop: 20, marginBottom: 20 }} item>
            {this.showLoginBar()}
          </Grid>

          <Grid item style={{ marginLeft: 20 }}>
            <Box
              sx={{
                boxShadow: "0  2px 5px rgba(154,160,185,0.25)",
                backgroundColor: "#F8F8F8",
                p: 1,
                m: 1,
                borderRadius: 5,
                fontWeight: "500",
                paddingLeft: "25px",
                paddingRight: "25px",
              }}
            >
              <Typography
                variant="h4"
                gutterBottom={true}
                align="left"
                style={{ fontSize: 20, marginTop: 6 }}
              >
                Secure data access
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom={true}
                align="left"
                style={{ marginBottom: 20 }}
              >
                Wyzr securely accesses your bank data through{" "}
                <Link
                  href="https://www.moneyhub.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Moneyhub
                </Link>
                , one of Europe's leading{" "}
                <Link
                  href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/908412/what-is-open-banking.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open Banking
                </Link>{" "}
                Data Providers.
              </Typography>
            </Box>

            <Box
              sx={{
                boxShadow: "0  2px 5px rgba(154,160,185,0.25)",
                backgroundColor: "#F8F8F8",
                p: 1,
                m: 1,
                borderRadius: 5,
                marginTop: 3,
                fontWeight: "500",
                paddingLeft: "25px",
                paddingRight: "25px",
              }}
            >
              <Typography
                variant="h4"
                gutterBottom={true}
                align="left"
                style={{ fontSize: 20, marginTop: 6 }}
              >
                FCA regulated
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom={true}
                align="left"
                style={{ marginBottom: 20 }}
              >
                Both Wyzr and{" "}
                <Link
                  href="https://www.moneyhub.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Moneyhub
                </Link>{" "}
                are regulated by the FCA. Wyzr is an appointed representative of{" "}
                <Link
                  href="https://www.moneyhub.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Moneyhub
                </Link>
                , which is fully authorised and regulated by the FCA.
              </Typography>
            </Box>
            <Box
              sx={{
                boxShadow: "0  2px 5px rgba(154,160,185,0.25)",
                backgroundColor: "#F8F8F8",
                p: 1,
                m: 1,
                borderRadius: 5,
                marginTop: 3,
                fontWeight: "500",
                paddingLeft: "25px",
                paddingRight: "25px",
              }}
            >
              <Typography
                variant="h4"
                gutterBottom={true}
                align="left"
                style={{ fontSize: 20, marginTop: 6 }}
              >
                Read only access with your consent
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom={true}
                align="left"
                style={{ marginBottom: 20 }}
              >
                Wyzr has read only access to your data with your express
                consent. It can’t modify your data or move your money. You can
                revoke your consent or delete your data at any time.
              </Typography>
            </Box>

            <Box
              sx={{
                boxShadow: "0  2px 5px rgba(154,160,185,0.25)",
                backgroundColor: "#F8F8F8",
                p: 1,
                m: 1,
                borderRadius: 5,
                marginTop: 3,
                fontWeight: "500",
                paddingLeft: "25px",
                paddingRight: "25px",
              }}
            >
              <Typography
                variant="h3"
                gutterBottom={true}
                align="left"
                style={{ fontSize: 20, marginTop: 6 }}
              >
                We don’t share your data
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom={true}
                align="left"
                style={{ fontSize: 18 }}
              >
                Your personal data is used only to provide valuable information
                to you. Wyzr doesn’t share your data with any external entity.
              </Typography>
            </Box>
            <Typography
              variant="subtitle"
              gutterBottom={true}
              align="left"
              style={{ marginTop: 20, color: "blue" }}
            >
              {/* <Link
                href="https://wyzr.uk/faqs/"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                Read more about data security in FAQ
              </Link> */}
            </Typography>
          </Grid>

          {/* <Grid
            container
            direction="column"
            alignItems="right"
            justifyContent="right"
            style={{
              height: 200,
              backgroundImage: `url(${LoginBottom})`,
              backgroundRepeat: "no-repeat",
            }}
          > */}
          <Grid
            container
            spacing={1}
            direction="column"
            item
            style={{
              minHeight: "20vh",
              backgroundImage: `url(${LoginBottom})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <Grid
              item
              justifyContent="center"
              alignSelf="center"
              style={{ display: "flex", marginTop: 16 }}
            >
              <Button
                onClick={() => window.open("https://wyzr.uk/faqs/")}
                // disabled={renderProps.disabled}
                style={{ backgroundColor: "#319403" }}
                variant="contained"
                sx={{ borderRadius: 10, paddingLeft: 5, paddingRight: 5 }}
              >
                <Typography
                  style={{ foneSize: 20, fontWeight: "bold" }}
                  display="inline"
                >
                  Read more about data security in FAQ
                </Typography>
              </Button>
            </Grid>
            {/* </Grid> */}
          </Grid>
        </Grid>
        <AppBar
          position="static"
          elevation={0}
          alignItems="center"
          component="footer"
          color="default"
        >
          <Typography style={{ fontSize: 14, fontWeight: 700 }} align="center">
            Wyzr Fintech Limited is registered in England & Wales with company
            number 12404769.
          </Typography>
          <Typography
            style={{ fontSize: 14, fontWeight: 700 }}
            gutterBottom={true}
            align="center"
          >
            Wyzr is registered as a Payment Services Directive Agent of Moneyhub
            Financial Technology Ltd, which is authorised and regulated by the
            Financial Conduct Authority. Find out more on the{" "}
            <Link
              href="https://register.fca.org.uk/s/firm?id=0014G00002sAbatQAC"
              target="_blank"
              rel="noopener noreferrer"
            >
              FCA Register
            </Link>
            .
          </Typography>
          <Typography
            style={{ fontSize: 14, fontWeight: 700 }}
            paragraph={true}
            align="center"
          >
            Copyright © 2022 Wyzr Fintech Limited
          </Typography>
        </AppBar>
      </>
    );
  }
}

export default Login;
